/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddStyle.scss';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import SelectFile from '../../../../SelectFile';
import { addStyleFromFile } from '../../../../../actions/district';

const ModalAlert = (props) => {
  return (
    <Modal {...props} >
      <Modal.Header className="bg-warning" closeButton>
        <Modal.Title>Błednie wypełniony formularz</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Wskaż plik oraz podaj nazwę stylu.<br /><br />
        <Button className="btn btn-warning pull-right" onClick={props.onHide}>Zamknij</Button>
        <br /><br />
      </Modal.Body>
    </Modal>
  );
};

const centerText = {
  textAlign: 'center',
};

class AddStyle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newStyleName: '',
      styleNameFromFile: '',
      fileList: null,
      fileName: null,
      isFileSelected: false,
      shouldReset: false,
      showModal: false,
    };

  }

  onFileSelect = (inputState) => {
    this.setState({ ...inputState }, () => this.setState({ styleNameFromFile: this.state.fileName.split('.')[0], shouldReset: false }));
  }

  onChangeNewStyleName = (e) => {
    this.setState({
      newStylename: e.target.value,
    });
  }

  onChangeStyleFromFile = (e) => this.setState({ styleNameFromFile: e.target.value });

  onSendClick = (e) => {
    if (!this.state.isFileSelected || !this.state.styleNameFromFile) {
      this.setState({ showModal: true });
    } else {
      this.props.addStyleFromFile(this.props.district.prefix, this.state.fileList, this.state.styleNameFromFile)
      .then(() => {
        this.setState({ styleNameFromFile: '', fileList: null, fileName: null, isFileSelected: false, shouldReset: true });
      });
    }
  }

  dismissModal = () => this.setState({ showModal: false });

  render() {
    return (
      <div className="col-xs-12">
        <h3 style={centerText}>Zaimportuj plik ze stylami</h3>
        <br />
        <h4 className="style-heading">Wybierz plik styli: &nbsp;</h4>
        <SelectFile
          shouldReset={this.state.shouldReset}
          notFullWidth
          accept=".sld"
          btnText=".SLD"
          multiple={false}
          labelType="warning"
          buttonType="default"
          onFileSelect={(inputState) => this.onFileSelect(inputState)}
        />
        <input value={this.state.styleNameFromFile} onChange={this.onChangeStyleFromFile} className="styleName" type="text" placeholder="Nazwa stylu" />
        <button onClick={this.onSendClick} type="button" className="btnSend">Wyślij</button>
        <h3 style={centerText}>lub utwórz nowy styl:</h3>
        <br />
        <h4 className="style-heading">Nazwa stylu: </h4>
        <br />
        <input className="styleName" type="text" placeholder="Nazwa stylu" onChange={(e) => this.onChangeNewStyleName(e)} />
        <button value={name} onClick={(e) => this.props.onAddNewStyle(e, this.state.newStylename)} type="button" className="btnCreate">Utwórz</button>
        <ModalAlert show={this.state.showModal} onHide={this.dismissModal} />
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});

const mapDispatch = {
  addStyleFromFile,
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddStyle));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddStyle/AddStyle.js